import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "admin-main-content",
  ref: "categoryBody"
}
const _hoisted_2 = { class: "admin-content-header" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h2", null, " 상품 카테고리 목록 ", -1)
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createVNode("div", { class: "card-tools" })
], -1)
const _hoisted_7 = { class: "card-body table-responsive p-0" }
const _hoisted_8 = { class: "table table-hover text-nowrap" }
const _hoisted_9 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "text-center" }, [
    /*#__PURE__*/_createVNode("th", null, "데이터 코드"),
    /*#__PURE__*/_createVNode("th", null, "카테고리명"),
    /*#__PURE__*/_createVNode("th", null, "사용여부")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", null, [
        _createVNode("button", {
          class: "btn btn-primary mr-3",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setEditMode(true)))
        }, " 순서 변경 "),
        _createVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goResgiter && _ctx.goResgiter(...args)))
        }, "신규 등록")
      ])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode("div", _hoisted_7, [
          _createVNode("table", _hoisted_8, [
            _hoisted_9,
            _createVNode("tbody", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.categoryList, (category) => {
                return (_openBlock(), _createBlock("tr", {
                  class: "text-center",
                  key: category.id,
                  onClick: ($event: any) => (_ctx.viewDetail(category.data_cd))
                }, [
                  _createVNode("td", null, _toDisplayString(category.data_cd), 1),
                  _createVNode("td", null, _toDisplayString(category.name), 1),
                  _createVNode("td", null, _toDisplayString(category.is_active ? '활성' : '미활성'), 1)
                ], 8, ["onClick"]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ], 512))
}